// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"styles_shareContainer__1wk8o","shareViaText":"styles_shareViaText__3shyV","uploadedImg":"styles_uploadedImg__3qbrZ","fileName":"styles_fileName__2TiW5"};